// Types
import type { TListingsStore } from '~/misc/listings/store/types';
import type { TAutomatedEmailSaleType } from '~/modules/opportunities/automated-email/types';
import { ESaleType } from '~/misc/listings/types';

// Store
import { useListingsStore } from '~/misc/listings/store';

export const useAutomatedEmailPatch = () => {
  const listingsStore: TListingsStore = useListingsStore();

  const patchId: ComputedRef<number | undefined> = computed<number | undefined>(
    () => listingsStore.selectedPatchId
  );

  const saleType: ComputedRef<TAutomatedEmailSaleType> = computed<TAutomatedEmailSaleType>(
    () => (listingsStore.filters.type === ESaleType.LETTINGS ? 'let' : 'sale')
  );

  const hasPatchId: ComputedRef<boolean> = computed<boolean>(() => patchId.value !== undefined);

  const isLettings: ComputedRef<boolean> = computed<boolean>(
    () => listingsStore.filters.type === ESaleType.LETTINGS
  );

  return {
    patchId,
    saleType,
    hasPatchId,
    isLettings,
  };
};
